exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.model-card[data-v-d91b605c]:hover {\n  text-decoration: none;\n}\n.card-text[data-v-d91b605c] {\n  color: #676868;\n}\n.cursor-pointer[data-v-d91b605c] {\n  cursor: pointer;\n}\n", ""]);

// exports
